import React, { useState, useEffect } from "react";
import axios from "axios";

const Dashboard = () => {

  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.sivammoto.in/api/dashboard/stats`);
        setDashboardData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">

          {dashboardData ? (
            <>
              <div className="row">
                {/* Monthly Sales */}
                <div className="col-lg-3 col-6">
                  <div className="small-box bg-info">
                    <div className="inner">
                      <h3>{dashboardData.monthly_sales}</h3>
                      <p>Monthly Sales</p>
                    </div>
                    <div className="icon">
                      <i className="ion ion-bag"></i>
                    </div>
                  </div>
                </div>

                {/* Yearly Sales */}
                <div className="col-lg-3 col-6">
                  <div className="small-box bg-success">
                    <div className="inner">
                      <h3>{dashboardData.yearly_sales}</h3>
                      <p>Annual Sales</p>
                    </div>
                    <div className="icon">
                      <i className="ion ion-stats-bars"></i>
                    </div>
                  </div>
                </div>

                {/* Monthly Revenue */}
                <div className="col-lg-3 col-6">
                  <div className="small-box bg-warning">
                    <div className="inner">
                      <h3>{dashboardData.monthly_revenue}</h3>
                      <p>Monthly Revenue</p>
                    </div>
                    <div className="icon">
                      <i className="ion ion-person-add"></i>
                    </div>
                  </div>
                </div>

                {/* Bikes Exchanged */}
                <div className="col-lg-3 col-6">
                  <div className="small-box bg-danger">
                    <div className="inner">
                      <h3>{dashboardData.bikes_exchanged}</h3>
                      <p>Monthly Exchange Bikes</p>
                    </div>
                    <div className="icon">
                      <i className="ion ion-pie-graph"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Cancelled Bills */}
                <div className="col-lg-3 col-6">
                  <div className="small-box bg-info">
                    <div className="inner">
                      <h3>{dashboardData.yearly_cancelled}</h3>
                      <p>Cancelled Bills</p>
                    </div>
                    <div className="icon">
                      <i className="ion ion-bag"></i>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p>Loading dashboard data...</p>  // ✅ Loading state
          )}
        </div>
      </section>
    </div>
  );
}

export default Dashboard